import makeStyles from "@mui/styles/makeStyles";
import { Theme } from "@mui/material/styles";

const styles = makeStyles<Theme>((theme) => ({
  container: {
    width: "35vw",
    [theme.breakpoints.down("md")]: {
      width: "45vw",
    },
    [theme.breakpoints.down("sm")]: {
      width: "55vw",
    },
  },
  message: {
    color: "#465869",
    font: "500 16px/24px Manrope",
  },
}));

export default styles;
